<div class='page-wrapper'>

  <div class="header-wrapper" *ngIf="currentImage">
    <div class="img-wrapper">
      <img [src]="currentImage">
    </div>
  </div>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>tag_faces</mat-icon>
        <div>Programação</div>
      </ng-template>

      <br>

      <div class="body-wrapper">

        <div class="body-left-wrapper">

          <mat-select placeholder="Data" [ngModel]='selectedDay' (ngModelChange)='selectDay($event)'>
            <mat-option *ngFor="let day of days" [value]="day.date">
              <span>{{day.date}}</span>
            </mat-option>
          </mat-select>

          <mat-select placeholder="Sala" [ngModel]='selectedRoom' (ngModelChange)='selectRoom($event)'>
            <mat-option *ngFor="let room of rooms" [value]="room.id">
              <span>{{room.name.substr(3)}}</span>
            </mat-option>
          </mat-select>

          <mat-select placeholder="Atividade" [ngModel]='selectedDepto' (ngModelChange)='selectDepartent($event)'>
            <mat-option *ngFor="let depto of deptos" [value]="depto.id">
              <div style="padding: 5px 0 5px 0;">{{depto.short}}</div>
            </mat-option>
          </mat-select>

          <mat-select placeholder="Palestrante" [ngModel]='selectedSpeaker' (ngModelChange)='selectSpeaker($event)'>
            <mat-option *ngFor="let speaker of speakers" [value]="speaker.id">
              <div style="padding: 6px 0 6px 0;">
                <span>{{speaker.name}}</span> <span *ngIf="speaker.state"> ({{speaker.state}})</span>
              </div>
            </mat-option>
          </mat-select>

          <button style="margin: 20px auto 10px auto;" (click)="filter()">
            Filtrar
          </button>

          <button style="margin: 10px auto 20px auto;" (click)="clearFilters()">
            Limpar filtros
          </button>

          <button style="margin: 10px auto 20px auto; background-color: rgb(19, 19, 135);" (click)="publish()">
            PUBLICAR
          </button>

        </div>

        <div class="body-right-wrapper">

          <div *ngIf="criteria" class="criteria">
            <img style="width: 30px; margin-left: 10px;" [src]='member_flag' *ngIf="member_flag">
            <span>{{criteria}}</span>
          </div>

          <div style="width: 100%; text-align: center;" *ngIf="notFound">

            <p style="margin-top: 50px; color: darkorange; font-size: 1.4em;">Nenhuma atividade encontrada <br> para os
              filtros selecionados</p>

          </div>

          <div *ngIf="isSpeaker" class='speaker-box'>
            <div class="speaker-left">
              <img [src]='member_image' *ngIf="member_image">
            </div>
            <div class="speaker-right" [innerHTML]="member_text">
            </div>
          </div>

          <div class="schedule" *ngIf="_activities.length > 0">

            <div *ngFor="let activity of _activities">

              <div class="activity-title-1">
                <span>{{activity.date }} &bull; {{activity.location.substr(3)}}</span>
              </div>

              <div class="activity-title-2">
                <div style="padding-bottom: 5px; color: gold">
                  <b>{{activity.depto}}</b>
                </div>

                <div [innerHTML]='activity.depto_text' style="color:whitesmoke;"></div>

                <a *ngIf="activity.sponsors[0]" target="_blank" [href]="activity.sponsors[0].link">
                  <img style="width:100%; margin: 5px 0 10px 0;" [src]="activity.sponsors[0].image">
                </a>
                <div style="padding-top: 5px; font-size: 1em; color: gold">
                  {{activity.name}} &bull; {{activity.startTime}}
                </div>
              </div>

              <div class="activity-display">

                <ul *ngFor="let aga of activity.agenda">
                  <div *ngIf="aga.member_id === selectedSpeaker">
                    <li style="color: blue;">
                      <img [src]="">
                      <span>{{aga.role_name}} - {{aga.member_name}} ({{aga.member_state}})</span>
                    </li>
                  </div>
                  <div *ngIf="aga.member_id !== selectedSpeaker">
                    <li>
                      <img [src]="">
                      <span>{{aga.role_name}} - {{aga.member_name}} ({{aga.member_state}}) </span>
                    </li>
                  </div>

                </ul>

                <div *ngFor="let topic of activity.topics">

                  <div class="topic-title-1">
                    <span><b>{{topic.startTime}}</b></span> - {{topic.name}}
                  </div>

                  <div class="topic-display">
                    <ul *ngFor="let agt of topic.agenda">
                      <div *ngIf="agt.member_id === selectedSpeaker">
                        <li style="color: blue;">{{agt.role_name}} - {{agt.member_name}} ({{agt.member_state}})</li>
                      </div>
                      <div *ngIf="agt.member_id !== selectedSpeaker">
                        <li> {{agt.role_name}} - {{agt.member_name}} ({{agt.member_state}})</li>
                      </div>
                    </ul>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>tag_faces</mat-icon>
        <div>Convidados</div>
      </ng-template>

      <div style="width: 700px; margin: auto;">
        <mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection='asc'
          matSortDisableClear=true>

          <!-- image -->
          <ng-container matColumnDef="image">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <img *ngIf="element.name !== '-Todos os palestrantes'" style="width: 40px; border-radius: 50px;"
                  [src]='element.image'>
              </ng-container>
            </mat-cell>
          </ng-container>


          <!-- flag -->
          <ng-container matColumnDef="flag">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <img *ngIf="element.name !== '-Todos os palestrantes'" style="width: 30px;" [src]='element.flag'>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.name !== '-Todos os palestrantes'">
                <div>{{ element.name }} - {{ element.state }} - {{ element.country }}</div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Header 
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
-->
          <!-- Row -->
          <mat-row (click)="showGuest(row)" *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
      </div>

    </mat-tab>
  </mat-tab-group>


</div>